/**
 * Pmd object for temporal use in pmd parser
 * @internal
 */
export var PmdObject;
(function (PmdObject) {
    let Bone;
    (function (Bone) {
        /**
         * Bone type
         */
        let Type;
        (function (Type) {
            Type[Type["Rotate"] = 0] = "Rotate";
            Type[Type["RotateMove"] = 1] = "RotateMove";
            Type[Type["Ik"] = 2] = "Ik";
            Type[Type["Unknown"] = 3] = "Unknown";
            Type[Type["IkLink"] = 4] = "IkLink";
            Type[Type["RotateEffect"] = 5] = "RotateEffect";
            Type[Type["IkTo"] = 6] = "IkTo";
            Type[Type["Invisible"] = 7] = "Invisible";
            Type[Type["Twist"] = 8] = "Twist";
            Type[Type["RotateRatio"] = 9] = "RotateRatio";
        })(Type = Bone.Type || (Bone.Type = {}));
    })(Bone = PmdObject.Bone || (PmdObject.Bone = {}));
})(PmdObject || (PmdObject = {}));
